import { render, staticRenderFns } from "./ShowEmisor.vue?vue&type=template&id=902bfc0e&scoped=true"
import script from "./ShowEmisor.vue?vue&type=script&lang=js"
export * from "./ShowEmisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902bfc0e",
  null
  
)

export default component.exports